import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=75e59b8b&scoped=true"
var script = {}
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=75e59b8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e59b8b",
  null
  
)

export default component.exports